import React from 'react';
import MaalrettetMeddelelse from '../MaalrettetMeddelelse';
import { IMaalrettetMeddelelser } from './MaalrettetMeddelelser.definition';

const MaalrettetMeddelelser = (props: IMaalrettetMeddelelser) => {
	const { meddelelser, isPDF = false } = props;

	if (!meddelelser || meddelelser.length < 1) {
		return null;
	}

	return (
		<>
			{ meddelelser.map((m, index) => <MaalrettetMeddelelse isPDF={ isPDF } key={ index } id={ 'artikel_0' + [index + 1] + '0_dim2' } reverse={ index % 2 !== 0 } { ...m } /> ) }
		</>
	);
};

export default MaalrettetMeddelelser;
